import { DefaultTheme } from "styled-components"

const themeConfig = {
  colors: {
    cta: "#2C00FA",
    ctaLight: "#5145FA",
    white: "#FFFFFF",
    black: "#000000",
    white80: "rgba(255,255,255,.8)",
    white80true: "#EEEEEE",
    white20: "rgba(255,255,255,.2)",
    darkGrey: "rgba(44, 44, 44, 1)",
    darkGrey05: "rgba(44, 44, 44, 0.05)",
    darkGrey10: "rgba(44, 44, 44, 0.10)",
    darkGrey15: "rgba(44, 44, 44, 0.15)",
    darkGrey20: "rgba(44, 44, 44, 0.20)",
    darkGrey40: "rgba(44, 44, 44, 0.20)",
    darkGrey60: "rgba(44, 44, 44, 0.60)",
    darkGrey80: "#65615C",
    undergraduate: "#AD0002",
    masters: "#F27300",
    mba: "#005AA0",
    doctorate: "#3D0D7B",
    executive: "#006E63",
    ivory: "#FFFAE7",
    ivoryDark: "#65615C",
    ivoryShadow: "#F1EEDF",
    ivoryShadow2: "#E7E4D6",
    ivoryShadow3: "#E1DED1",
    pinkLight: "#FFE8FC",
    pinkDark: "#FF7AE9",
    pink: "#FFCEFB",
    greenLight: "#DEFCED",
    greenDark: "#64E3A1",
    green: "#C2FCDF",
    blueLight: "#E5F9FF",
    blueDark: "#00D9FF",
    blue: "#B9EEFD",
  },
  breakPoints: {
    max: "1768px",
    wide: "1264px",
    desktop: "1024px",
    tablet: "768px",
    mobile: "414px",
  },
  fonts: {
    bembo: "Bembo",
    circularBook: "EFCircularWeb-Book",
    circularMedium: "EFCircularWeb-Medium",
    circularBold: "EFCircularWeb-Bold",
    circularItalic: "EFCircularWeb-BookItalic",
  },
}

const mixins = {
  mixins: {
    container: `
        width: 100%;
        margin: 0 auto;
        padding: 0 32px;
        max-width: ${themeConfig.breakPoints.wide};
        @media (max-width: ${themeConfig.breakPoints.wide}) {
            max-width: ${themeConfig.breakPoints.desktop};
        }
        @media (max-width: ${themeConfig.breakPoints.tablet}) {
            padding: 0 24px;
        }
        @media (max-width: ${themeConfig.breakPoints.mobile}) {
            padding: 0 16px;
        }
    `,
    // Page Title
    h1: `
        font-family: ${themeConfig.fonts.bembo};
        color: ${themeConfig.colors.darkGrey};
        margin: 0;
        font-size: 48px;
        line-height: 52px;
        @media (max-width: ${themeConfig.breakPoints.desktop}){
            font-size: 40px;
            line-height: 44px;
        }
        @media (max-width: ${themeConfig.breakPoints.tablet}){
            font-size: 33px;
            line-height: 37px; 
        }
    `,
    heading: `
        font-family: ${themeConfig.fonts.circularBold};
        color: ${themeConfig.colors.darkGrey};
        margin: 0;
        font-size: 48px;
        line-height: 52px;
        @media (max-width: ${themeConfig.breakPoints.tablet}){
            font-size: 32px;
            line-height: 36px; 
        }
    `,
    // Section Title
    h2: `
        font-family: ${themeConfig.fonts.bembo};
        color: ${themeConfig.colors.darkGrey};
        margin: 0;
        font-size: 36px;
        line-height: 40px;
        @media (max-width: ${themeConfig.breakPoints.desktop}){
            font-size: 32px;
            line-height: 36px;
        }
        @media (max-width: ${themeConfig.breakPoints.tablet}){
            font-size: 28px;
            line-height: 32px; 
        }
    `,
    // Subsection Title
    subsectionTitle: `
        font-family: ${themeConfig.fonts.circularMedium};
        color: ${themeConfig.colors.darkGrey};
        margin: 0;
        font-size: 26px;
        line-height: 30px;
        @media (max-width: ${themeConfig.breakPoints.desktop}){
            font-size: 22px;
            line-height: 26px;
        }
    `,
    // Paragraph
    body: `
        font-family: ${themeConfig.fonts.circularBook};
        font-size: 16px;
        line-height: 22px;
        color: ${themeConfig.colors.darkGrey80};
        margin: 0;
    `,
    markdown: `
        display: flex;
        flex-direction: column;

        & p {
            margin: 8px 0;
            font-family: ${themeConfig.fonts.circularBook};
            font-size: 16px;
            line-height: 22px;
            max-width: ${themeConfig.breakPoints.tablet};
            color: ${themeConfig.colors.darkGrey80};

            &.title__h2{
                font-family: ${themeConfig.fonts.bembo};
                color: ${themeConfig.colors.darkGrey};
                font-size: 36px;
                line-height: 40px;
                margin-top: 24px;
                @media (max-width: ${themeConfig.breakPoints.desktop}){
                    font-size: 32px;
                    line-height: 36px;
                }
                @media (max-width: ${themeConfig.breakPoints.tablet}){
                    font-size: 28px;
                    line-height: 32px; 
                }
            }
            &.title__h3{
                font-family: ${themeConfig.fonts.circularMedium};
                color: ${themeConfig.colors.darkGrey};
                font-size: 26px;
                line-height: 30px;
                margin-top: 24px;
                @media (max-width: ${themeConfig.breakPoints.desktop}){
                    font-size: 22px;
                    line-height: 26px;
                }
            }
        }
        & strong, & b{
            font-family: ${themeConfig.fonts.circularMedium};
            font-size: 16px;
            line-height: 22px;
            color: ${themeConfig.colors.black};
            margin: 0;
        }
        & a{
            font-family: ${themeConfig.fonts.circularBook};
            text-decoration: underline;
            font-size: 16px;
            line-height: 22px;
            color: ${themeConfig.colors.black};
        }
        & ul, & ol{
            padding: 0;
            max-width: ${themeConfig.breakPoints.tablet};
            list-style-type: '- ';
            margin: 8px 0 8px 16px;

            & li{
                margin: 0;
                margin-top: 8px;
                font-family: ${themeConfig.fonts.circularBook};
                font-size: 16px;
                line-height: 22px;
                color: ${themeConfig.colors.black};

                &:nth-of-type(1){
                    margin-top: 0;
                }
                & a{
                    text-decoration: underline; 
                    display: initial;
                }
            }
        }
        & >:nth-child(1), & >:nth-child(1).title__h2, & >:nth-child(1).title__h3 {
            margin-top: 0;
        }
        & >:nth-last-child(1), & >:nth-child(1).title__h2, & >:nth-child(1).title__h3{
            margin-bottom: 0;
        }
    `,
    markdownAlt: `
        display: flex;
        flex-direction: column;

        & p{
            margin: 8px 0;
            font-family: ${themeConfig.fonts.circularBook};
            font-size: 16px;
            line-height: 22px;
            max-width: ${themeConfig.breakPoints.tablet};
            color: ${themeConfig.colors.white80true};

            &.title__h2{
                font-family: ${themeConfig.fonts.bembo};
                color: ${themeConfig.colors.white};
                font-size: 36px;
                line-height: 40px;
                margin-top: 24px;
                @media (max-width: ${themeConfig.breakPoints.desktop}){
                    font-size: 32px;
                    line-height: 36px;
                }
                @media (max-width: ${themeConfig.breakPoints.tablet}){
                    font-size: 28px;
                    line-height: 32px; 
                }
            }
            &.title__h3{
                font-family: ${themeConfig.fonts.circularMedium};
                color: ${themeConfig.colors.white};
                font-size: 26px;
                line-height: 30px;
                margin-top: 24px;
                @media (max-width: ${themeConfig.breakPoints.desktop}){
                    font-size: 22px;
                    line-height: 26px;
                }
            }
        }
        & strong, & b{
            font-family: ${themeConfig.fonts.circularMedium};
            font-size: 16px;
            line-height: 22px;
            color: ${themeConfig.colors.white};
            margin: 0;
        }
        & a{
            font-family: ${themeConfig.fonts.circularBook};
            text-decoration: underline;
            font-size: 16px;
            line-height: 22px;
            color: ${themeConfig.colors.white};
        }
        & ul, & ol{
            padding: 0;
            max-width: ${themeConfig.breakPoints.tablet};
            list-style-type: '- ';
            margin: 8px 0 8px 16px;

            & li{
                margin: 0;
                margin-top: 8px;
                font-family: ${themeConfig.fonts.circularBook};
                font-size: 16px;
                line-height: 22px;
                color: ${themeConfig.colors.white};

                &:nth-of-type(1){
                    margin-top: 0;
                }
                & a{
                    text-decoration: underline; 
                    display: initial;
                }
            }
        }
        & >:nth-child(1), & >:nth-child(1).title__h2, & >:nth-child(1).title__h3 {
            margin-top: 0;
        }
        & >:nth-last-child(1), & >:nth-child(1).title__h2, & >:nth-child(1).title__h3{
            margin-bottom: 0;
        }
    `,
    // Paragraph Bold
    bold: `
        font-family: ${themeConfig.fonts.circularMedium};
        font-size: 16px;
        line-height: 22px;
        color: ${themeConfig.colors.black};
        margin: 0;
    `,
    boldAlt: `
        font-family: ${themeConfig.fonts.circularMedium};
        font-size: 16px;
        line-height: 22px;
        color: ${themeConfig.colors.white};
        margin: 0;
    `,
    // link
    link: `
        font-family: ${themeConfig.fonts.circularBook};
        text-decoration: underline;
        font-size: 16px;
        line-height: 22px;
        color: ${themeConfig.colors.black};
    `,
    // Label
    label: `
      font-family: ${themeConfig.fonts.circularBook};
      font-size: 14px;
      line-height: 18px;
      color: ${themeConfig.colors.darkGrey80};
      margin: 0;
      @media (max-width: ${themeConfig.breakPoints.tablet}){
        font-size: 12px;
        line-height: 16px;
      }
    `,
    headingAccent: `
        content: "";
        width: 48px;
        height: 1px;
        background: ${themeConfig.colors.darkGrey};
        display: block;
        margin-top: 8px;
        @media (max-width: ${themeConfig.breakPoints.tablet}){
            width: 32px;
        }
  `,
    // hover effect
    hover: `
      transform: translateY(-4px);
      box-shadow: rgb(44 44 44 / 15%) 0px 16px 16px;
    `,
    hoverTransition: `
      transition: all 0.2s ease 0s;
    `,
  },
}

const theme: DefaultTheme = { ...themeConfig, ...mixins }

export { theme }
